import { render } from "./ColComponent.vue?vue&type=template&id=7422616e"
import script from "./ColComponent.vue?vue&type=script&lang=js"
export * from "./ColComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__